import { render } from "./PageNumber13.vue?vue&type=template&id=18355540&scoped=true"
import script from "./PageNumber13.vue?vue&type=script&lang=js"
export * from "./PageNumber13.vue?vue&type=script&lang=js"

import "./PageNumber13.vue?vue&type=style&index=0&id=18355540&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18355540"]])

export default __exports__